import React from 'react';
import type { FormInstance } from './types';

export interface FormContextProps {
  form: FormInstance;
  disabled?: boolean;
  name?: string;
  validateTrigger?: string | string[];
}

export const FormContext = React.createContext<FormContextProps>({
  form: {} as FormInstance,
});

